import { render } from "./CVIntroduction.vue?vue&type=template&id=fd19952c&scoped=true"
import script from "./CVIntroduction.vue?vue&type=script&lang=js"
export * from "./CVIntroduction.vue?vue&type=script&lang=js"

import "./CVIntroduction.vue?vue&type=style&index=0&id=fd19952c&scoped=true&lang=css"
import "./CVIntroduction.vue?vue&type=style&index=1&id=fd19952c&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fd19952c"]])

export default __exports__